angular.module('impactx.user').directive('ixUserControlSetting', function()
{
    return {
        scope: {
            relation : '=',
            object: '=',
            settings: "=",
            name: "@",
            trns: "=",
            dialogData: "=",
            searchLabel: "@",
            availableEntryPoint: "@",
            usrId: "="
        },
        controller: "UserControlSettingsCtrl",
        controllerAs: "userControlSettingsCtrl",
        restrict: 'E',
        templateUrl: 'modules/userdialog/templates/usercontrolsetting.tmpl.html'
    };
});